import script from "./Model.vue?vue&type=script&setup=true&lang=js"
export * from "./Model.vue?vue&type=script&setup=true&lang=js"

import "./Model.vue?vue&type=style&index=0&id=f0d9478e&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0d9478e"]])

export default __exports__